module.exports = __webpack_public_path__ + "static/media/arrow-right-orange.c4f91afe.png";